import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { dataUrlToBlob } from "common/utilities/dataUrlToBlob";
import { logger } from "common/utilities/logger";
import { uploadImageFailure, uploadImageSuccess } from "domains/collection/actions";
import type { UploadImageAction } from "domains/collection/actionTypes";
import type { ImageResponse } from "domains/collection/types/collectionResponses";

export function* uploadImageSaga({ payload }: UploadImageAction) {
  try {
    const body = new FormData();
    body.append("object_type", payload.type);
    body.append("image", dataUrlToBlob(payload.image));
    const response: ImageResponse = yield apiFetch("image", { body, method: "POST" });
    yield put(uploadImageSuccess({ response, type: payload.type }));
  } catch (error) {
    logger.error("[uploadImageSaga] Failed to upload image", error);
    yield put(uploadImageFailure());
  }
}
